import { getToken } from "../utils/commonHelper";
import axiosInstance from "../utils/AxiosInstance";
const API_URL = `${process.env.REACT_APP_API_URL}`; // Replace with your actual API URL
 

const customHeaders = {
  'Content-Type': 'application/json',
};


export const getAuth = async (data: { email: string, password: string }) => {
  const fcm_token = await getToken();
  console.log("admin atuh service ::", { fcm_token });

  const response = await axiosInstance.post(`${API_URL}/auth/login`, { ...data, fcm_token }, { headers: customHeaders });
  return response.data;
}

export const getUserByIdQuery = async (userId: string) => {
  const response = await axiosInstance.get(`${API_URL}/auth/${userId}`, { headers: customHeaders });
  return response.data;
};

// Update SAP Number
export const updateSapNumber = async (
  user_id: string,
  sap_no: string,
  exp_date: string,
  health_exp_date: string,
  email: string,
  legalApprove: boolean,
  commercialApprove: boolean,
  userApprovals?: any[]
) => {
  const response = await axiosInstance.put(
    `${API_URL}/auth/update-sap/${user_id}`,
    {
      sap_no,
      exp_date,
      health_exp_date,
      email,
      legalApprove,
      commercialApprove,
      userApprovals,
    },
    { headers: customHeaders }
  );
  return response.data;
};

// Get a user's linked companies (persisted approvals + live SAP list)
export const getUserCompanies = async (userId: string) => {
  const response = await axiosInstance.get(
    `${API_URL}/auth/user-companies/${userId}`,
    { headers: customHeaders }
  );
  return response.data;
};

// Update Status
export const updateStatus = async (userId: string, status: string) => {
  const response = await axiosInstance.put(
    `${API_URL}/auth/update-status/${userId}`,
    { status },
    { headers: customHeaders }
  );
  return response.data;
};

export const getCaptchaQuery = async () => {
  console.log("called inside authApi", { API_URL });

  const response = await axiosInstance.get(`${API_URL}/generate-captcha`, { headers: customHeaders });
  return response.data;
};
